export default "__VITE_ASSET__CJQO6FJ5__"